"use strict";
exports.__esModule = true;
var api_1 = require("./api");
var banners_1 = require("./banners");
// tslint:disable-next-line:no-any
function mergeMiddlewares() {
    var middlewares = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        middlewares[_i] = arguments[_i];
    }
    return Promise.all(middlewares)
        .then(function (data) {
        return data.reduce(function (acc, x) { return Object.assign(acc, x); }, {});
    })["catch"](function (err) {
        console.error(err);
        throw err;
    });
}
exports.mergeMiddlewares = mergeMiddlewares;
// tslint:disable-next-line:max-line-length
function calculatedParamsMiddleware() {
    var now = new Date();
    return Promise.resolve({
        pd: now.getDate().toString(),
        pw: now.getDay().toString(),
        pv: now.getHours().toString(),
        prr: document.referrer ? encodeURIComponent(document.referrer) : '',
        dl: location.href
    });
}
exports.calculatedParamsMiddleware = calculatedParamsMiddleware;
function targetsMiddleware(type, params) {
    return api_1.fetchTargets(type, params);
}
exports.targetsMiddleware = targetsMiddleware;
function typeParamsMiddleware(type) {
    return Promise.resolve(banners_1.getBannerByType(type));
}
exports.typeParamsMiddleware = typeParamsMiddleware;
function bannerMiddleware(bannerType, targetParams) {
    if (targetParams === void 0) { targetParams = {}; }
    return mergeMiddlewares(targetsMiddleware(bannerType, targetParams), typeParamsMiddleware(bannerType), calculatedParamsMiddleware());
}
exports.bannerMiddleware = bannerMiddleware;
//# sourceMappingURL=middlewares.js.map